/* eslint-disable no-useless-escape */
import { forEach, indexOf } from "lodash";
import { EventBus } from "src/bus/eventBus";

export default {
    methods: {
        normalizeTable() {
            forEach(this.$el.querySelectorAll("table"), e => {
                // TinyMCE sometimes adds an incorrect height which results in overlapping of content. This removes it.
                e.style.height = "auto";
                // TinyMCE sometimes adds border which is deprecated. This removes it.
                e.removeAttribute("border");
            });
        },
        normalizeTitles() {
            forEach(this.$el.querySelectorAll("h1"), e => {
                e.classList.add("cc-inside-h1");
                this._removeTitleId(e);
            });
            forEach(this.$el.querySelectorAll("h2"), e => {
                e.classList.add("cc-inside-h2");
                this._removeTitleId(e);
            });
            forEach(this.$el.querySelectorAll("h3"), e => {
                e.classList.add("cc-inside-h3");
                this._removeTitleId(e);
            });
            forEach(this.$el.querySelectorAll("h4"), e => {
                e.classList.add("cc-inside-h4");
                this._removeTitleId(e);
            });
            forEach(this.$el.querySelectorAll("h5"), e => {
                e.classList.add("cc-inside-h5");
                this._removeTitleId(e);
            });
        },

        normalizeCCNLinks(mode) {
            forEach(this.$el.querySelectorAll("a"), e => {
                if (e.classList.contains("init")) return;
                const href = e.getAttribute("href");
                let params = null;
                if ((params = href.match(/\/ccn\/(.*?)\/d(\d+)\/?(ca|pres|ob)?(?:#?)(.*)/is))) {
                    e.classList.add("init");
                    e.setAttribute("href", this._getInternalLink(params[1], params[2], params[3], params[4]));
                    if (mode === "linked-content") {
                        e.setAttribute("target", "_blank");
                    }
                }
            });
        },
        normalizeLinkedContentsLinks() {
            forEach(this.$el.querySelectorAll("a"), e => {
                if (e.classList.contains("init")) return;
                const href = e.getAttribute("href");
                let params = null;
                const { pathname, queryParams } = this._parseHref(href);
                if ((params = pathname.match(/\/linked\/([^\/#?]+)/is)) && !queryParams.format) {
                    e.classList.add("init");
                    e.setAttribute("href", this._getLinkedContent(params[1]));
                    e.addEventListener("click", e => {
                        e.preventDefault();
                        EventBus.$emit("linked-content:show", params[1]);
                    });
                }
            });
        },

        normalizeArticleLinks() {
            const conventionRouteNames = [
                "convention-presentation",
                "convention-champ-dapplication",
                "convention-obligations",
                "convention-obligations-slug",
            ];
            forEach(this.$el.querySelectorAll("a"), e => {
                if (e.classList.contains("init")) return;
                const href = e.getAttribute("href");
                let params = null;
                const { pathname, queryParams } = this._parseHref(href);
                if ((params = pathname.match(/\/linked\/([^\/#?]+)/is)) && queryParams.format === "article") {
                    e.classList.add("init");
                    e.setAttribute("href", this._getArticleLink(params[1]));
                    if (indexOf(conventionRouteNames, this.$route.name) >= 0) {
                        e.addEventListener("click", e => {
                            e.preventDefault();
                            EventBus.$emit("linked-content:show", params[1]);
                        });
                    }
                }
            });
        },

        normalizeArticlesCategoryLinks() {
            forEach(this.$el.querySelectorAll("a"), e => {
                if (e.classList.contains("init")) return;
                const href = e.getAttribute("href");
                let params = null;
                if ((params = href.match(/\/article-category\/([^\/#]+)/is))) {
                    e.classList.add("init");
                    e.setAttribute("href", this._getArticleCategoryLink(params[1]));
                }
            });
        },

        normalizeDocumentLinks() {
            forEach(this.$el.querySelectorAll("a"), e => {
                if (e.classList.contains("init")) return;
                const href = e.getAttribute("href");
                let params = null;
                if ((params = href.match(/\/documents\/([^\/]+\.pdf)/is))) {
                    e.classList.add("init");
                    e.setAttribute("href", `/documents/${params[1]}`);
                }
            });
        },

        _getLinkedContent(id) {
            return this.$router.resolve({ name: "linked-content", params: { id } }).href;
        },

        _getArticleLink(slugOrContentId) {
            return this.$router.resolve({ name: "article", params: { slugOrContentId } }).href;
        },

        _getArticleCategoryLink(name) {
            return this.$router.resolve({ name: "mag", query: { category: name } }).href;
        },

        _getInternalLink(conventionId, variantNumber, tab, slug) {
            const params = {
                conventionId,
                variantNumber,
            };
            if (tab == "ob") {
                return this.$router.resolve({
                    name: "convention-obligations-slug",
                    params: { ...params, slug },
                }).href;
            } else if (tab == "ca") {
                return this.$router.resolve({ name: "convention-champ-dapplication", params }).href;
            } else {
                return this.$router.resolve({ name: "convention-presentation", params }).href;
            }
        },

        _removeTitleId(element) {
            const regExp = new RegExp(/(.*?\|\s?)/);
            element.innerHTML = element.innerHTML.replace(regExp, "");
        },
        _parseHref(href) {
            const queryParams = {};
            if (!href) return { pathname: "", queryParams };
            const url = new URL(href, location);
            url.searchParams.forEach((value, key) => (queryParams[key] = value));
            return { pathname: url.pathname, queryParams };
        },
    },
};
